document.addEventListener("DOMContentLoaded", () => {
  // 复制函数：
  function copyToClip2(content) {
    var aux = document.createElement("input");
    aux.setAttribute("value", content);
    document.body.appendChild(aux);
    aux.select();
    document.execCommand("copy");
    document.body.removeChild(aux);
  }

  // 给复制按钮判定点击事件
  $(".right-code-btn").click(function () {
    // 获取复制的内容
    let text = $(".right-code").text();
    // 将内容赋值给函数
    copyToClip2(text);
   $(this).text('copied ✔')
   $(this).css('background-color', '#345701')
  });

  $(".left-code-btn").click(function () {
    // 获取复制的内容
    let text = $(".left-code").text();
    // 将内容赋值给函数
    copyToClip2(text);
   $(this).text('copied ✔')
   $(this).css('background-color', '#345701')
  });
});
